module.exports = __webpack_public_path__ + "static/img/3.c2e5f79.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/3.png
// module id = DNdq
// module chunks = 0